// eslint-disable-next-line @typescript-eslint/no-explicit-any
const arraysHaveCommonItems = (arr1: any[], arr2: any[]): boolean => {
    const set1 = new Set(arr1);

    return arr2.some((item) => set1.has(item));
};

export { arraysHaveCommonItems };
